import { useEffect } from "react";
import { Card, Container, Row } from "reactstrap";
import { ECommerce, ProductPage } from "../../../../constants";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { fetchProductJsonData } from "../../../../reduxToolkit/reducers/eCommerce/productSlice";
import ProductSlider from "./ProductSlider";
import Details from "./details";
import BrandLists from "./BrandLists";
import ClothDetails from "./ClothDetails";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

//This component serves as the main container for the product page, fetching product data and rendering various sections like product slider, details, and brand lists.
const ProductPageContainer = () => {

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchProductJsonData());
  }, [dispatch]);

  return (
    <>
      <Breadcrumbs mainTitle={ProductPage} parent={ECommerce} />
      <Container fluid>
        <div>
          <Row className="product-page-main p-0">
            <ProductSlider />
            <Details />
            <BrandLists />
            <Card>
              <Row className="product-page-main">
                <ClothDetails />
              </Row>
            </Card>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default ProductPageContainer;